import {
  PATCH_USER_SUCCESS,
  PATCH_USER_ERROR,
  CLEAR_PATCH_USER,
  ADD_CUSTOM_DOMAIN_SUCCESS,
  ADD_CUSTOM_DOMAIN_ERROR,
  CLEAR_CUSTOM_DOMAIN,
  FETCH_CUSTOM_DOMAIN_INFO,
  FETCH_CUSTOM_DOMAIN_INFO_ERROR,
  CLEAR_CUSTOM_DOMAIN_INFO,
  DELETE_CUSTOM_DOMAIN_SUCCESS,
  DELETE_CUSTOM_DOMAIN_ERROR,
  CLEAR_DELETE_CUSTOM_DOMAIN,
} from 'redux/settings/types';

const initialState = {
  patchUserSuccess: null,
  patchUserError: null,
  postCustomDomainSuccess: null,
  postCustomDomainError: null,
  customDomainInfo: null,
  customDomainInfoError: null,
  deteteCustomDomainSuccess: null,
  deteteCustomDomainError: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case PATCH_USER_SUCCESS:
      return {
        ...state,
        patchUserSuccess: action.payload.data,
        patchUserError: null,
      };
    case PATCH_USER_ERROR:
      return {
        ...state,
        patchUserSuccess: null,
        patchUserError: action.payload.data,
      };
    case CLEAR_PATCH_USER:
      return {
        ...state,
        patchUserSuccess: null,
        patchUserError: null,
      };
    case ADD_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        postCustomDomainSuccess: action.payload.data,
        postCustomDomainError: null,
      };
    case ADD_CUSTOM_DOMAIN_ERROR:
      return {
        ...state,
        postCustomDomainSuccess: null,
        postCustomDomainError: action.payload.data,
      };
    case CLEAR_CUSTOM_DOMAIN:
      return {
        ...state,
        postCustomDomainSuccess: null,
        postCustomDomainError: null,
      };
    case FETCH_CUSTOM_DOMAIN_INFO:
      return {
        ...state,
        customDomainInfo: action.payload.data,
        customDomainInfoError: null,
      };
    case FETCH_CUSTOM_DOMAIN_INFO_ERROR:
      return {
        ...state,
        customDomainInfo: null,
        customDomainInfoError: action.payload.data,
      };
    case CLEAR_CUSTOM_DOMAIN_INFO:
      return {
        ...state,
        customDomainInfo: null,
        customDomainInfoError: null,
      };
    case DELETE_CUSTOM_DOMAIN_SUCCESS:
      return {
        ...state,
        deteteCustomDomainSuccess: action.payload.data === '' ? true : false,
        deteteCustomDomainError: null,
      };
    case DELETE_CUSTOM_DOMAIN_ERROR:
      return {
        ...state,
        deteteCustomDomainSuccess: null,
        deteteCustomDomainError: action.payload.data === '' ? true : false,
      };
    case CLEAR_DELETE_CUSTOM_DOMAIN:
      return {
        ...state,
        deteteCustomDomainSuccess: null,
        deteteCustomDomainError: null,
      };
    default:
      return state;
  }
};
